import React, { useEffect, useState, forwardRef, useMemo } from 'react';
import Card from '@material-ui/core/Card';
import { Route, Link, useRouteMatch } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import ListItemText from '@material-ui/core/ListItemText';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import ListSubheader from '@material-ui/core/ListSubheader';
import { Service } from '../../Api';
import { connect } from 'react-redux';
import CardRowMaterial from './CardRowMaterial';

const useStyles = makeStyles((theme) => ({
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const handleChange = async (set, src, marker, key, name, setName, selected) => {
  let s = await Service.get(src, (status, fetched) => fetched);
  s !== selected && set(s);
  s !== selected && setName(name);
  s !== selected && marker(key);
  return console.log('closed');
};

const ListItemLink = (props) => {
  const {
    primary,
    to,
    setSelectedTopic,
    source,
    setListMarker,
    setPrimary,
    padded,
    category,
  } = props;
  const renderLink = useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <Link to={to} {...itemProps} innerRef={ref} />
      )),
    [to]
  );

  return (
    <li>
      {category && (
        <div
          className="py-0 my-0"
          style={{
            paddingLeft: '15px',
          }}
        >
          <FolderIcon />{' '}
          <ListSubheader
            style={{
              paddingLeft: '10px',
              display: 'inline',
            }}
          >
            {category}
          </ListSubheader>
        </div>
      )}
      {!category && (
        <ListItem
          button
          component={renderLink}
          onClick={() =>
            !category &&
            handleChange(
              setSelectedTopic,
              source,
              setListMarker,
              to.substring(to.lastIndexOf('/') + 1),
              primary,
              setPrimary
            )
          }
          style={{ paddingLeft: padded ? '30px' : '15px' }}
          selected={
            window.location.href.substring(
              window.location.href.lastIndexOf('/') + 1
            ) === to.substring(to.lastIndexOf('/') + 1)
          }
        >
          <FolderIcon />
          &nbsp; &nbsp; &nbsp;
          <ListItemText primary={primary} />
        </ListItem>
      )}
    </li>
  );
};

const Topic = ({ selectedTopic }) => (
  <CardRowMaterial containerized cards={selectedTopic} />
);

const FileBrowser = (props) => {
  let { path, url } = useRouteMatch();
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [listMarker, setListMarker] = useState('');
  const [primaryName, setPrimary] = useState(null);
  const classes = useStyles();
  const { topics, header } = props;
  let currentUrl = window.location.href.substring(
    window.location.href.lastIndexOf('/') + 1
  );
  useEffect(() => {
    let isSelected = !!(Array.isArray(selectedTopic) && selectedTopic.length);
    let requestLoad =
      (!isSelected && currentUrl !== '') || (!isSelected && currentUrl === url);
    let topicFound = topics.find(({ route }) => currentUrl === route);
    !isSelected &&
      !!topicFound &&
      requestLoad &&
      handleChange(
        setSelectedTopic,
        topicFound.source,
        setListMarker,
        topicFound.route,
        topicFound.name,
        setPrimary,
        selectedTopic
      );
  }, []);
  return (
    <Container maxWidth="xl" className="my-3 px-0 mx-0">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={3} xs={12}>
          <Card>
            <div className={classes.demo}>
              <List dense className="pb-0">
                {header && <ListSubheader>{header}</ListSubheader>}
                {topics.map(
                  ({ route, name, source, padded, icon, category }, key) => (
                    <ListItemLink
                      to={`${url}/${route}`}
                      category={category}
                      primary={name}
                      source={source}
                      listMarker={listMarker}
                      setListMarker={setListMarker}
                      padded={padded}
                      keyMarker={key}
                      icon={icon}
                      setPrimary={setPrimary}
                      setSelectedTopic={setSelectedTopic}
                    />
                  )
                )}
              </List>
            </div>
          </Card>
        </Grid>
        <Grid item md={9} xs={12}>
          <Card className={`p-2 ${topics === [] ? 'pb-0' : 'pb-1'}`}>
            <Route path={`${path}/:topicId`}>
              <Topic
                selectedTopic={selectedTopic}
                setSelectedTopic={setSelectedTopic}
                primaryName={primaryName}
                {...props}
              />
            </Route>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

const FileManagerComponent = (props) => {
  return (
    <div>
      <FileBrowser {...props} />
    </div>
  );
};

FileManagerComponent.propTypes = {};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {})(FileManagerComponent);
